import React, { FC } from 'react';
import PrevArrowIcon from 'assets/chevron-left';
import NextArrowIcon from 'assets/chevron-right';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  direction: 'prev' | 'next';
}

const CalendarNavigationButton: FC<Props> = ({ direction, ...props }) => {
  return (
    <button
      type="button"
      tabIndex={0}
      aria-label={direction === 'prev' ? 'Previous month' : 'Next month'}
      {...props}
    >
      {direction === 'prev' && (
        <PrevArrowIcon color="var(--way-palette-black-80)" scale={1.5} />
      )}
      {direction === 'next' && (
        <NextArrowIcon color="var(--way-palette-black-80)" scale={1.5} />
      )}
    </button>
  );
};

export default CalendarNavigationButton;
